import React, { useState, useMemo } from 'react';
import ComponentCard from './ComponentCard';
import { countFaultedComponents } from './componentSeverity';
import StatusPill from '../../../shared/components/pill/StatusPill';

export default function ComponentStatusAccordion({ components: componentsProp = [] }) {
  const [open, setOpen] = useState(false);
  const components = useMemo(() => componentsProp, [componentsProp]);
  const faultedCount = countFaultedComponents(components);

  const tone = faultedCount === 0 ? 'success' : 'danger';

  function handleHeaderClick(event) {
    event.preventDefault();
    setOpen((v) => !v);
  }

  function handleHeaderKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setOpen((v) => !v);
    }
  }

  return (
    <div className="card mb-3 pt-3 pb-3">
      <div
        className="card-body pt-0 pb-0 d-flex align-items-center justify-content-between"
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={handleHeaderClick}
        onKeyDown={handleHeaderKeyDown}
        style={{ userSelect: 'none', cursor: 'pointer' }}
      >
        <div className="d-flex align-items-center gap-2">
          <i className="bi bi-puzzle-fill fs-5 text-primary" />
          <span className="fw-semibold">Component Status</span>
        </div>
        <span className="d-flex align-items-center gap-2">
          <StatusPill tone={tone} size="touch">
            {faultedCount} Faulted
          </StatusPill>
          <i className={`bi bi-chevron-${open ? 'up' : 'down'} ms-1`} />
        </span>
      </div>
      {open && (
        <div className="px-2 pb-2 pt-1">
          {components.length === 0 ? (
            <div className="text-muted p-4">No component data available.</div>
          ) : (
            components.map((component) => (
              <ComponentCard
                key={component.external_key || component.id}
                component={component}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}
